import { useSelector } from "react-redux";
import { selectCurrentUser } from "../../store/user/user.selector";
import { netural400, neturalBlack } from "../../utils/colors";
import CustomLabel from "../shared/label/custom-label.component";
import {
  additionaldiscount,
  additionalPointTax,
  arps,
  autoShip,
  coupon,
  handlingFees,
  REFERRAL_CREDIT,
  savingUnlockFee,
  subtotal,
  tax,
  total,
} from "../../utils/title-constants";

const OrderSummaryPricing = ({
  itemType,
  pricing,
  selectedCheckoutCart,
  promotionalCode,
  applyReferral,
}) => {
  const {
    subTotal,
    serviceFees,
    additionalDiscount,
    additionalPointsTax,
    referralCredit,
    autoShipDiscount,
    couponCode,
    discountTotal,
    taxAmount,
    finalCheckoutTotal,
  } = pricing;
  const currentUser = useSelector(selectCurrentUser);
  return (
    <div
      style={{
        marginTop: "5%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <CustomLabel
          style={{
            color: netural400,
            fontSize: "14px",
            fontWeight: "500",
          }}
        >
          {subtotal}
        </CustomLabel>
        <CustomLabel
          style={{
            color: netural400,
            fontSize: "14px",
            fontWeight: "500",
          }}
        >
          $ {subTotal}
        </CustomLabel>
      </div>
      {applyReferral ? (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            marginTop: "2%",
          }}
        >
          <CustomLabel
            style={{
              color: netural400,
              fontSize: "14px",
              fontWeight: "500",
            }}
          >
            {REFERRAL_CREDIT}
          </CustomLabel>
          <CustomLabel
            style={{
              color: netural400,
              fontSize: "14px",
              fontWeight: "500",
            }}
          >
            - $ {parseFloat(referralCredit).toFixed(2)}
          </CustomLabel>
        </div>
      ) : null}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          marginTop: "2%",
        }}
      >
        <CustomLabel
          style={{
            color: netural400,
            fontSize: "14px",
            fontWeight: "500",
          }}
        >
          {arps} {currentUser.subscription.subscriptionDiscount}%
        </CustomLabel>
        <CustomLabel
          style={{
            color: netural400,
            fontSize: "14px",
            fontWeight: "500",
          }}
        >
          -$ {discountTotal}
        </CustomLabel>
      </div>
      {additionalDiscount && additionalDiscount !== 0 ? (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            marginTop: "2%",
          }}
        >
          <CustomLabel
            style={{
              color: netural400,
              fontSize: "14px",
              fontWeight: "500",
            }}
          >
            {additionaldiscount}
          </CustomLabel>
          <CustomLabel
            style={{
              color: netural400,
              fontSize: "14px",
              fontWeight: "500",
            }}
          >
            -$ {additionalDiscount.toFixed(2)}
          </CustomLabel>
        </div>
      ) : null}
      {serviceFees && serviceFees !== 0 ? (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            marginTop: "2%",
          }}
        >
          <CustomLabel
            style={{
              color: netural400,
              fontSize: "14px",
              fontWeight: "500",
            }}
          >
            {savingUnlockFee}
          </CustomLabel>
          <CustomLabel
            style={{
              color: netural400,
              fontSize: "14px",
              fontWeight: "500",
            }}
          >
            $ {serviceFees.toFixed(2)}
          </CustomLabel>
        </div>
      ) : null}

      {additionalPointsTax && additionalPointsTax !== 0 ? (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            marginTop: "2%",
          }}
        >
          <CustomLabel
            style={{
              color: netural400,
              fontSize: "14px",
              fontWeight: "500",
            }}
          >
            {additionalPointTax}
          </CustomLabel>
          <CustomLabel
            style={{
              color: netural400,
              fontSize: "14px",
              fontWeight: "500",
            }}
          >
            $ {additionalPointsTax?.toFixed(2)}
          </CustomLabel>
        </div>
      ) : null}
      {selectedCheckoutCart?.sellingPlan && (
        <div
          style={{
            display: "flex",
            marginTop: "2%",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <CustomLabel
            style={{
              color: netural400,
              fontSize: "14px",
              fontWeight: "500",
            }}
          >
            {autoShip} {selectedCheckoutCart.sellingPlan.discount}%
          </CustomLabel>
          <CustomLabel
            style={{
              color: netural400,
              fontSize: "14px",
              fontWeight: "500",
            }}
          >
            -$ {parseFloat(autoShipDiscount).toFixed(2)}
          </CustomLabel>
        </div>
      )}
      {couponCode > 0 && (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            marginTop: "2%",
          }}
        >
          <CustomLabel
            style={{
              color: netural400,
              fontSize: "14px",
              fontWeight: "500",
            }}
          >
            {coupon}:{" "}
            {promotionalCode.type === "percentage"
              ? promotionalCode.discountPercentage + " %"
              : promotionalCode.discountedAmount + " $"}
          </CustomLabel>
          <CustomLabel
            style={{
              color: netural400,
              fontSize: "14px",
              fontWeight: "500",
            }}
          >
            -$ {couponCode}
          </CustomLabel>
        </div>
      )}

      {itemType === "product" || itemType === "autoship" ? (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            marginTop: "2%",
          }}
        >
          <CustomLabel
            style={{
              color: netural400,
              fontSize: "14px",
              fontWeight: "500",
            }}
          >
            {handlingFees}
          </CustomLabel>
          <CustomLabel
            style={{
              color: netural400,
              fontSize: "14px",
              fontWeight: "500",
            }}
          >
            $ {selectedCheckoutCart.shippingCost}
          </CustomLabel>
        </div>
      ) : null}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          marginTop: "2%",
        }}
      >
        <CustomLabel
          style={{
            color: netural400,
            fontSize: "14px",
            fontWeight: "500",
          }}
        >
          {tax} {selectedCheckoutCart.taxRate}%
        </CustomLabel>
        <CustomLabel
          style={{
            color: netural400,
            fontSize: "14px",
            fontWeight: "500",
          }}
        >
          $ {taxAmount}
        </CustomLabel>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          marginTop: "2%",
        }}
      >
        <CustomLabel
          style={{
            color: neturalBlack,
            fontSize: "14px",
            fontWeight: "600",
          }}
        >
          {total}
        </CustomLabel>
        <CustomLabel
          style={{
            color: neturalBlack,
            fontSize: "14px",
            fontWeight: "600",
          }}
        >
          $ {finalCheckoutTotal}
        </CustomLabel>
      </div>
    </div>
  );
};

export default OrderSummaryPricing;
